// Generated by GitHub Copilot
const Footer = () => {
  const year = new Date().getFullYear();
  const sinceYear = 2026;
  const displayYear = year > sinceYear ? `${sinceYear}–${year}` : String(sinceYear);

  return (
    <footer className="border-t border-[var(--glass-border)] bg-[var(--glass-surface)] py-5 text-center text-sm text-[var(--text-secondary)]">
      <p>
        Copyright &copy; {displayYear}, Ram Prakash Dhulipudi. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
